import { useQuery } from '@tanstack/react-query';

import { getLineChannel } from 'api/line';
import { queryKeys } from 'constants/queryKeys';
import { lineStrings } from 'constants/strings';
import { useAuth } from 'contexts/AuthContext';
import { toErrorMessage } from 'hooks/utils';
import type { TLineChannelDetail } from 'types';

type UseLineChannelAccountResult = {
  account: TLineChannelDetail | undefined;
  loading: boolean;
  error: string | undefined;
};

export function useLineChannelAccount(
  lineChannelId?: number,
): UseLineChannelAccountResult {
  const { user } = useAuth();
  const strings = lineStrings.edit;

  // 認証済みかつIDがある場合のみ詳細取得を実行する。
  const query = useQuery({
    queryKey: [queryKeys.LINE_CHANNEL_DETAIL, lineChannelId, user?.uid],
    enabled: Boolean(user?.uid && lineChannelId !== undefined),
    queryFn: () => {
      if (lineChannelId === undefined) {
        throw new Error(strings.errors.loadFailed);
      }
      return getLineChannel(lineChannelId);
    },
    retry: false,
  });

  return {
    account: query.data,
    loading:
      Boolean(user?.uid && lineChannelId !== undefined) && query.isPending,
    error: query.error
      ? toErrorMessage(query.error, strings.errors.loadFailed)
      : undefined,
  };
}
